import { Expose } from "@nts/std/serialization";
import { BaseIdentity } from './base-identity';
import { BaseRootModel } from './base-root-model';
import { OCCModelInterface } from './occ-model.interface';


export class OCCModel<TIdentity extends BaseIdentity> extends BaseRootModel<TIdentity> implements OCCModelInterface {

  static override PROPERTY_LIST: string[] = [
    ...BaseRootModel.PROPERTY_LIST,
    'occ',
    'reservedData'
  ];

  @Expose()
  occ: string;

  @Expose()
  reservedData: string;

  // @Expose()
  // oCCV: string;

  // @Expose()
  // oCCVN: number;

}
